import { http } from '../utils/http';
import Pagination from '../interfaces/common/pagination';
import Paging from '../interfaces/common/paging';
import SortFormatterUtils from '../utils/sortFormatterUtils';
import OrderSource from '../interfaces/output/orderSource';

export default class OrderSourceApi {
    static fetchOrderSourceById = async(orderSourceId: string): Promise<OrderSource> => {
        const { data } = await http.get<OrderSource>(`ordersource/${orderSourceId}`);

        return data;
    };

    static fetchOrderSources = async(paging: Paging): Promise<Pagination<OrderSource>> => {
        const url = SortFormatterUtils.addSortingToUrl(paging, null, '/ordersource');

        const { data } = await http.get<Pagination<OrderSource>>(url);

        return data;
    };
}
